import React, { ReactNode } from 'react';
import { StyleSheetManager } from 'styled-components';

export interface PrintContentContainerProps {
  id: string;
  children: ReactNode;
}

export default function PrintContentContainer({
  id,
  children,
}: PrintContentContainerProps): JSX.Element {
  return (
    // For a given subtree involving styled-components
    // it switches to the text node-based CSS injection system for adding styles to the DOM
    // to add styles to the print frame
    <StyleSheetManager disableCSSOMInjection>
      <div id={id}>{children}</div>
    </StyleSheetManager>
  );
}
